import { render, staticRenderFns } from "./AccountRegister.vue?vue&type=template&id=33ac54a2&scoped=true"
import script from "./AccountRegister.vue?vue&type=script&lang=js"
export * from "./AccountRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ac54a2",
  null
  
)

export default component.exports